import { inject, observer } from 'mobx-react';
import * as React from 'react';
export var NewSaleFailure = inject('config')(observer(function (props) {
    return (React.createElement("div", null,
        React.createElement("h2", { className: "page-title" }, "Sign up was unsuccessful"),
        React.createElement("div", { className: "sale-error panel" },
            React.createElement("h3", null,
                "There was an error completing your order.",
                ' ',
                props.config.saleFailureAdvice),
            React.createElement("strong", null, "Duplicate service already exists."))));
}));
//# sourceMappingURL=NewSaleFailure.js.map